import React from "react";

import ReportActions from "../ReportActions";
import ReportStatus from "../ReportStatus";
import { useReport } from "../api";
import { AthleteSelfReport, LegalFooter } from "../renderers/AthleteReports";
import { usePeriodParam } from "../usePeriodParam";

/** /athlete/reportes — "Mi reporte". */
const AthleteReportsPage = () => {
  const [days, setDays] = usePeriodParam();
  const params = { days };
  const query = useReport("athlete-self", params);

  return (
    <div className="flex flex-1 flex-col overflow-y-auto bg-paper">
      <ReportActions
        title="Mi reporte"
        reportId="athlete-self"
        reportTitle="Mi reporte"
        params={params}
        period={days}
        onPeriodChange={setDays}
        allowGuardian
      />
      {query.data ? (
        <>
          <main className="mx-auto w-full max-w-[1080px] px-4 pt-5 pb-6 sm:px-5">
            <AthleteSelfReport data={query.data.data} />
          </main>
          <LegalFooter />
        </>
      ) : (
        <ReportStatus query={query} />
      )}
    </div>
  );
};

export default AthleteReportsPage;
